// @ts-strict-ignore
import React, { SetStateAction, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon, Tooltip } from '@node-space/ui-components'
import { useApprovalsContext } from 'hooks/useApprovalsContext'
import { ApprovalBandDraft, useApprovalRangeConfig } from './hooks/useApprovalRangeSettings'

interface ApprovalRangeControlsProps {
  rowIndex: number
  approvalBands: ApprovalBandDraft[]
  setApprovalBands: (value: SetStateAction<ApprovalBandDraft[]>) => void
  setIsApprovalRuleInvalid?: (value: SetStateAction<boolean>) => void
}

const ApprovalRangeControls = ({
  approvalBands,
  rowIndex,
  setApprovalBands,
  setIsApprovalRuleInvalid,
}: ApprovalRangeControlsProps) => {
  const { t } = useTranslation()

  const { permissions } = useApprovalsContext()
  const {
    addButtonIsVisible,
    deletebuttonIsVisible,
    approvalRangeIsInvalid,
    currentRowToValue,
    rowCount,
    isCurrentRowRangeInvalid,
  } = useApprovalRangeConfig(approvalBands, rowIndex)

  const handleAddNewRow = (index: number) => {
    const values = [...approvalBands]
    values[index].to = ''
    values.push({ from: 0, approvals: 2 })

    setApprovalBands(values)
  }

  const handleRemoveRow = (index: number) => {
    const values = [...approvalBands]
    values?.splice(index, 1)
    if (values?.length === 1) {
      values[0].to = undefined
      values[0].approvals = values?.[0]?.approvals || 1
    } else {
      values[index - 1].to = undefined
    }

    setApprovalBands(values)
  }

  useEffect(() => {
    setIsApprovalRuleInvalid(approvalRangeIsInvalid)
  }, [currentRowToValue, rowCount, approvalRangeIsInvalid])

  const AddNewRowButton = useMemo(() => {
    return (
      <Button
        onClick={() => handleAddNewRow(rowIndex)}
        noPadding
        variant="ghost"
        iconElement={<Icon name="Plus" />}
      />
    )
  }, [handleAddNewRow])

  return (
    <>
      {addButtonIsVisible && permissions?.canEdit && (
        <>
          {isCurrentRowRangeInvalid ? (
            <Tooltip
              bodyContent={t('approvals.addNewRowIsDisabledError')}
              type="complex"
              position="bottom"
            >
              {AddNewRowButton}
            </Tooltip>
          ) : (
            AddNewRowButton
          )}
        </>
      )}

      {deletebuttonIsVisible && permissions?.canEdit && (
        <Button
          onClick={() => handleRemoveRow(rowIndex)}
          noPadding
          variant="ghost"
          iconElement={<Icon name="Trash" />}
        />
      )}
    </>
  )
}

export default ApprovalRangeControls
